import { Component, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from './core/services/configurationService';
import { AdobeAnalyticsService } from '@coreModule/services/adobe-analytics.service';
import { TrackingGlobals } from '@shared/enum/trackingGlobals';
import { DOCUMENT } from '@angular/common';
import { ThemeService } from '@shared/modules/theme/services/theme.service';
import { Theme } from '@shared/modules/theme/interfaces/theme.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  private version: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private titleService: Title,
    private http: HttpClient,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private renderer: Renderer2,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    this.loadAppVersion();
    this.setMainThemeFile();
    this.setCustomPropertiesTheme();
    const browserLang = this.translate.getBrowserLang();
    const languages: string[] = ConfigurationService.appConfig.general.internationalization.languages;
    const languageToUse = languages.includes(browserLang) ? browserLang : ConfigurationService.appConfig.general.internationalization.default;
    this.translate.use(languageToUse);

    this.adobeAnalyticsService.init();
    this.adobeAnalyticsService.pushEvent(TrackingGlobals.eventNames.GDPR_ENABLED, true, true);
    this.adobeAnalyticsService.pushEvent(TrackingGlobals.eventNames.COOKIE_CONSENT, false, true);
  }

  setMainThemeFile(): void {
    const useNewUxUi = ConfigurationService.appConfig.general.enableNewUxUi;
    this.loadExternalStylesheet(useNewUxUi ? 'main-theme-v2' : 'main-theme-v1');
  }

  setCustomPropertiesTheme(): void {
    const useNewUxUi = ConfigurationService.appConfig.general.enableNewUxUi;
    if (useNewUxUi) {
      const activeTheme = this.themeService.getActiveTheme();
      this.fillUpThemeProperties(activeTheme);
    }
  }

  loadExternalStylesheet(bundleName: string) {
    const cssFile = `${bundleName}.css`;
    const style = this.renderer.createElement('link') as HTMLLinkElement;
    this.renderer.setProperty(style, 'rel', 'stylesheet');
    this.renderer.setProperty(style, 'href', cssFile);
    this.renderer.setProperty(style, 'id', bundleName);
    this.renderer.appendChild(this.document.head, style);
  }

  fillUpThemeProperties(themeProps: Theme) {
    for (const element in themeProps) {
      if (typeof themeProps[element] === 'object') {
        this.fillUpThemeProperties(themeProps[element]);
      } else {
        this.renderer.setStyle(this.document.documentElement, element, themeProps[element], 2);
      }
    }
  }

  loadAppVersion() {
    this.http.get('assets/version.json').subscribe(async (version) => {
      this.version = version;
      this.titleService.setTitle(this.version.name);
      this.adobeAnalyticsService.pushEvent(TrackingGlobals.eventNames.APPLICATION_VERSION, this.version.appVersion, true);
    });
  }
}
